import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import ProgramsShowcase from './components/ProgramsShowcase';
import FeaturesSection from './components/FeaturesSection';
import MissionSection from './components/MissionSection';
import WhySection from './components/WhySection';
import NightAndGroupSection from './components/NightAndGroupSection';
import MinistryConnectionsBanner from './components/MinistryConnectionsBanner';
import TestimonialsSection from './components/TestimonialsSection';
import CEOPreview from './components/CEOPreview';
import ServiceAreaSection from './components/ServiceAreaSection';
import ContactSection from './components/ContactSection';
import CTASection from './components/CTASection';
import NightSessionFAB from './components/NightSessionFAB';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'EducationalOrganization',
  name: 'Creative Institute LLC',
  url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
  description: 'Mobile music, arts and creative development serving Fayetteville, North Carolina and surrounding areas. Expert instruction for all ages — we come to you.',
  telephone: '910-242-4567',
  email: 'info@creativeinstitutellc.com',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Fayetteville',
    addressRegion: 'NC',
    addressCountry: 'US',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: '35.0527',
    longitude: '-78.8784',
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      opens: '09:00',
      closes: '21:00',
    },
  ],
  founder: { '@type': 'Person', name: 'Jaquan Little' },
  areaServed: { '@type': 'State', name: 'North Carolina' },
  knowsAbout: ['Music Education', 'Arts Education', 'Recording Studio', 'Audio Production', 'Vocal Arts', 'Neurodivergent Development'],
  sameAs: [],
};

export default function HomePage() {
  return (
    <main>
      <SEOHead
        title="Creative Institute LLC | Mobile Music & Arts Education Across North Carolina"
        description="Creative Institute LLC brings mobile music, arts & creative development to multiple cities across North Carolina. Expert instruction for all ages — we come to you. Where Every Creative Mind Matters."
        keywords="music lessons North Carolina, mobile arts education NC, creative development program NC, Creative Institute LLC, mobile music instruction, arts education multiple cities NC, Jaquan Little"
        canonical="/"
        jsonLd={homeJsonLd}
      />
      <NightSessionFAB />
      <HeroSection />
      <StatsSection />
      <ProgramsShowcase />
      <FeaturesSection />
      <MissionSection />
      <WhySection />
      <MinistryConnectionsBanner />
      <NightAndGroupSection />
      <TestimonialsSection />
      <CEOPreview />
      <ServiceAreaSection />
      <ContactSection />
      <CTASection />
    </main>
  );
}
